var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CFD8DC"
    },
    d: "M443.499,417.941l-181.333-128c-3.689-2.606-8.62-2.606-12.309,0l-181.333,128 c-2.837,1.999-4.525,5.254-4.523,8.725v10.667C64,443.224,68.776,448,74.667,448h362.667c5.891,0,10.667-4.776,10.667-10.667 v-10.667C448.007,423.2,446.328,419.945,443.499,417.941z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M262.165,289.941l-181.333-128c-4.807-3.405-11.465-2.268-14.87,2.539 c-1.281,1.808-1.967,3.97-1.962,6.186v256c-0.012,5.891,4.755,10.676,10.646,10.688c2.216,0.004,4.378-0.682,6.186-1.962 l181.333-128c4.813-3.397,5.961-10.052,2.564-14.865c-0.702-0.995-1.569-1.862-2.564-2.564V289.941z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EEEEEE"
    },
    d: "M442.24,161.195c-3.546-1.812-7.802-1.525-11.072,0.747l-181.333,128 c-4.813,3.397-5.961,10.052-2.564,14.865c0.702,0.995,1.569,1.862,2.564,2.564l181.333,128c4.807,3.405,11.465,2.268,14.87-2.539 c1.277-1.802,1.962-3.956,1.962-6.165v-256C448,166.681,445.779,163.028,442.24,161.195z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECEFF1"
    },
    d: "M468.8,71.339C467.362,66.96,463.275,64,458.667,64H53.333c-5.891,0-10.667,4.776-10.667,10.667 c0,3.357,1.581,6.519,4.267,8.533L249.6,232.533c3.762,2.77,8.889,2.77,12.651,0L464.917,83.2 C468.631,80.495,470.195,75.716,468.8,71.339z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F44336"
    },
    d: "M458.667,64c-2.308,0-4.554,0.749-6.4,2.133L256,210.752L59.733,66.133 C57.887,64.749,55.641,64,53.333,64C23.878,64,0,87.878,0,117.333v277.333C0,424.122,23.878,448,53.333,448h21.333 c5.891,0,10.667-4.776,10.667-10.667v-246.08l164.501,116.139c3.689,2.606,8.62,2.606,12.309,0l164.523-116.139v246.08 c0,5.891,4.776,10.667,10.667,10.667h21.333C488.122,448,512,424.122,512,394.667V117.333C512,87.878,488.122,64,458.667,64z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/emailIcon.e7e438ad868d2e85de50bdab93821a81.svg";
export { ForwardRef as ReactComponent };